import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Button, Group, Stack, Table, Text, Title, Tooltip } from '@mantine/core';
import { IconEdit, IconPlus, IconTrash } from '@tabler/icons-react';

import { useRemoveObjectionResponse } from '../api/removeObjectionResponse';
import { objectionResponsesTypes } from '../types';

import { ObjectionResponseModal } from './ObjectionResponseModal';

import { ConfirmModal } from '@/components/Modals/Confirm';
import { COLORS } from '@/utils/colors';

type Props = {
  aiId: number;
  responses: objectionResponsesTypes.ObjectionResponse[];
};

export const ObjectionResponsesTable = ({ aiId, responses }: Props) => {
  const removeMutation = useRemoveObjectionResponse();

  return (
    <Stack>
      <Group justify="space-between">
        <Title order={2}>Objection Responses (AI ID: {aiId})</Title>
        <Button
          leftSection={<IconPlus size={16} />}
          onClick={() => NiceModal.show(ObjectionResponseModal, { aiId, mode: 'create' })}
        >
          Add Objection Response
        </Button>
      </Group>

      <Table striped highlightOnHover withTableBorder>
        <Table.Thead>
          <Table.Tr>
            <Table.Th style={{ width: 60 }}>#</Table.Th>
            <Table.Th>User message</Table.Th>
            <Table.Th>Recommended response</Table.Th>
            <Table.Th style={{ width: 120 }}>Actions</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {responses.map((response, index) => (
            <Table.Tr key={response._id}>
              <Table.Td>{index + 1}</Table.Td>
              <Table.Td>
                <Text size="sm">{response.objectionText}</Text>
              </Table.Td>
              <Table.Td>
                <Text size="sm" style={{ whiteSpace: 'pre-wrap' }}>
                  {response.responseText}
                </Text>
              </Table.Td>
              <Table.Td>
                <Group gap="xs">
                  <Tooltip label="Edit">
                    <ActionIcon
                      variant="filled"
                      radius="md"
                      onClick={() =>
                        NiceModal.show(ObjectionResponseModal, { aiId, mode: 'edit', response })
                      }
                      aria-label="Edit objection response"
                    >
                      <IconEdit color={COLORS.text} />
                    </ActionIcon>
                  </Tooltip>
                  <Tooltip label="Delete">
                    <ActionIcon
                      variant="filled"
                      color="red"
                      radius="md"
                      onClick={() =>
                        NiceModal.show(ConfirmModal, {
                          title: 'Delete objection response?',
                          onSuccess: () => removeMutation.mutate({ id: response._id, aiId }),
                        })
                      }
                      aria-label="Delete objection response"
                    >
                      <IconTrash color={COLORS.text} />
                    </ActionIcon>
                  </Tooltip>
                </Group>
              </Table.Td>
            </Table.Tr>
          ))}
          {responses.length === 0 && (
            <Table.Tr>
              <Table.Td colSpan={4}>
                <Text size="sm" c="dimmed">
                  No objections yet for this template.
                </Text>
              </Table.Td>
            </Table.Tr>
          )}
        </Table.Tbody>
      </Table>
    </Stack>
  );
};
